// extracted by mini-css-extract-plugin
export default {"buttonBase":"MomentTrimModal-module__buttonBase_pmzIM","confirmButton":"MomentTrimModal-module__confirmButton_X4bHM","backButton":"MomentTrimModal-module__backButton_FhB83"};